<template>
  <div>
    <a-card
      v-if="dataBasic.length !== 0"
      :bordered="false"
      class="header-solid h-full staff-info-card"
      :bodyStyle="{ paddingTop: 0, paddingBottom: 0 }"
      style="height: 500px"
    >
      <template #title>
        <div class="card-custom-header">
          <div class="header-icon-box icon-basic">
            <a-icon type="idcard" />
          </div>
          <div class="header-text-group">
            <h5 class="header-title font-web m-0">Basic</h5>
            <span class="header-subtitle font-web">ข้อมูลพื้นฐานการทำงาน</span>
          </div>
        </div>
      </template>

      <a-descriptions class="mb-20" :column="1">
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            ID :
            <span class="text-dark f-18 font-semibold">{{
              dataBasic[0].code
            }}</span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            Time working :
            <span v-if="dataBasic[0].flexible">
              <a-badge :count="`Flexible Time`" :number-style="{ backgroundColor: '#52c41a' }" />
            </span>
            <span v-else>
              <span class="f-18 text-success font-semibold"
                >{{ dataBasic[0].time_start_working }}
              </span>
              -
              <span class="f-18 text-danger font-semibold">{{
                moment(dataBasic[0].time_start_working, "HH:mm:ss")
                  .add(9, "hours")
                  .format("HH:mm:ss")
              }}</span>
            </span>
          </p>
        </a-descriptions-item>
        
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">Position :</p>
          <p class="font-semibold m-0">{{ dataBasic[0].position }}</p>
          <p class="font-web font-semibold m-0">{{ dataBasic[0].position_thai }}</p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">Department :</p>
          <p class="font-semibold m-0">
            {{ dataBasic[0].department.name_eng }}
          </p>
          <p class="font-web font-semibold m-0">
            {{ dataBasic[0].department.name_thai }}
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">Contract Type :</p>
          <p class="font-semibold m-0">
            {{ dataBasic[0].contract.name_eng }}
          </p>
          <p class="font-web font-semibold m-0">
            {{ dataBasic[0].contract.name_thai }}
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Work start date :<span class="ml-5 font-semibold text-dark">{{
              moment(dataBasic[0].worked).format("LL")
            }}</span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Worked :
            <span class="ml-5 font-semibold text-dark">{{ dataWork }}</span>
          </p>
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
export default {
  props: {
    dataBasic: {
      type: Array,
      default: () => [],
    },
    dataWork: {
      type: String,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    chkBlankData(val) {
      return val !== null && val !== "null" && val !== "" ? val : "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-info-card {
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07);
  }
}

.card-custom-header {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.header-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  margin-right: 12px;
  flex-shrink: 0;
}

.icon-basic {
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
  color: #6d28d9;
}

.header-text-group {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
}

.header-subtitle {
  font-size: 11.5px;
  color: #8f9bb3;
  margin-top: 1px;
}

.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-14 {
  font-size: 14px;
}
</style>